import { Node } from '@msdyn365-commerce-modules/utilities';
import { Image, IImageData } from '@msdyn365-commerce/core';
import * as React from 'react';

import { IBuyboxAddToCartViewProps } from '@msdyn365-commerce-modules/buybox';
import { IBuyboxViewProps } from '../hei-buybox-v2';
import { ProductCode } from './ProductCode';
import classnames from 'classnames';
import { ArrayExtensions, getFallbackImageUrl } from '@msdyn365-commerce-modules/retail-actions';

const FloatingSummary = ({
    addToCart,
    price,
    title,
    data: { product },
    isInViewport,
    state,
    context,
    resources
}: IBuyboxViewProps & { isInViewport: boolean }) => {
    const { mediaLocations } = state;

    const image: IImageData | null = ArrayExtensions.hasElements(mediaLocations)
        ? {
              src: mediaLocations[0].Uri,
              altText: mediaLocations[0].AltText
          }
        : null;

    const fallbackImageUrl = getFallbackImageUrl(product.result?.ItemId, context.actionContext.requestContext.apiSettings);

    return (
        <div
            className={classnames('hei-buybox-floating-summary', {
                hidden: isInViewport !== false
            })}
        >
            <div className='container'>
                {image && (
                    <div className='floating-summary-thumbnail'>
                        <Image
                            className='floating-summary-thumbnail-img'
                            {...image}
                            gridSettings={context.request.gridSettings || {}}
                            imageSettings={{
                                viewports: {
                                    xs: { q: 'w=60&h=60&m=6', w: 60, h: 60 },
                                    lg: { q: 'w=80&h=80&m=8', w: 80, h: 80 }
                                }
                            }}
                            loadFailureBehavior='empty'
                            fallBackSrc={fallbackImageUrl}
                            bypassHideOnFailure
                        />
                    </div>
                )}
                <div className='floating-summary-title-price-container'>
                    <div className='floating-summary-title'>
                        {title}
                        <ProductCode product={product.result} resources={resources} />
                    </div>
                    <div className='floating-summary-price'>{price}</div>
                </div>
                <div className='floating-summary-add-to-cart'>{addToCart && _renderAddToCart(addToCart)}</div>
            </div>
        </div>
    );
};

const _renderAddToCart = (addToCart: IBuyboxAddToCartViewProps): JSX.Element => {
    const { ContainerProps, errorBlock, button } = addToCart;

    return (
        <Node {...ContainerProps}>
            {errorBlock}
            {button}
        </Node>
    );
};

export { FloatingSummary };
